/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerInsuranceInovalonPayer } from './ScreenerInsuranceInovalonPayer';
import {
    ScreenerInsuranceInovalonPayerFromJSON,
    ScreenerInsuranceInovalonPayerFromJSONTyped,
    ScreenerInsuranceInovalonPayerToJSON,
    ScreenerInsuranceInovalonPayerToJSONTyped,
} from './ScreenerInsuranceInovalonPayer';
import type { StediPayer } from './StediPayer';
import {
    StediPayerFromJSON,
    StediPayerFromJSONTyped,
    StediPayerToJSON,
    StediPayerToJSONTyped,
} from './StediPayer';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
    InsurancePayorToJSONTyped,
} from './InsurancePayor';

/**
 * 
 * @export
 * @interface ScreenerInsurance
 */
export interface ScreenerInsurance {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    payor: InsurancePayor;
    /**
     * 
     */
    type?: ScreenerInsuranceTypeEnum;
    /**
     * 
     */
    state?: string;
    /**
     * 
     */
    coverage_priority: ScreenerInsuranceCoveragePriorityEnum;
    /**
     * 
     */
    plan_name?: string;
    /**
     * 
     */
    medicare_number?: string;
    /**
     * 
     */
    medicaid_number?: string;
    /**
     * 
     */
    plan_number?: string;
    /**
     * 
     */
    group_number?: string;
    /**
     * 
     */
    is_overridden_by_user: boolean;
    /**
     * 
     */
    is_active_payer?: boolean;
    /**
     * 
     */
    inovalon_payer?: ScreenerInsuranceInovalonPayer;
    /**
     * 
     */
    inovalon_mapping_mismatch?: boolean;
    /**
     * 
     */
    stedi_payer?: StediPayer;
    /**
     * 
     */
    stedi_mapping_status?: ScreenerInsuranceStediMappingStatusEnum;
    /**
     * 
     */
    stedi_enrollment_required?: boolean;
    /**
     * 
     */
    stedi_mapping_mismatch?: boolean;
    /**
     * 
     */
    received_from_cache_key?: string;
    /**
     * 
     */
    network_status_override?: ScreenerInsuranceNetworkStatusOverrideEnum;
    /**
     * 
     */
    coverage_status?: ScreenerInsuranceCoverageStatusEnum;
    /**
     * Computed network status based on network_status_override or payer INN/OON configuration
     */
    network_status?: ScreenerInsuranceNetworkStatusEnum;
}


/**
 * @export
 */
export const ScreenerInsuranceTypeEnum = {
    Commercial: 'Commercial',
    ManagedMedicare: 'Managed Medicare',
    ManagedMedicaid: 'Managed Medicaid',
    Medicare: 'Medicare',
    Medicaid: 'Medicaid',
    Other: 'Other',
    PrivatePay: 'Private Pay',
} as const;
export type ScreenerInsuranceTypeEnum = typeof ScreenerInsuranceTypeEnum[keyof typeof ScreenerInsuranceTypeEnum];

/**
 * @export
 */
export const ScreenerInsuranceCoveragePriorityEnum = {
    Primary: 'Primary',
    Secondary: 'Secondary',
    Tertiary: 'Tertiary',
} as const;
export type ScreenerInsuranceCoveragePriorityEnum = typeof ScreenerInsuranceCoveragePriorityEnum[keyof typeof ScreenerInsuranceCoveragePriorityEnum];

/**
 * @export
 */
export const ScreenerInsuranceStediMappingStatusEnum = {
    Resolved: 'resolved',
    Missing: 'missing',
    NotSupported: 'not_supported',
    Ambiguous: 'ambiguous',
} as const;
export type ScreenerInsuranceStediMappingStatusEnum = typeof ScreenerInsuranceStediMappingStatusEnum[keyof typeof ScreenerInsuranceStediMappingStatusEnum];

/**
 * @export
 */
export const ScreenerInsuranceNetworkStatusOverrideEnum = {
    InNetwork: 'in_network',
    OutOfNetwork: 'out_of_network',
    Undetermined: 'undetermined',
} as const;
export type ScreenerInsuranceNetworkStatusOverrideEnum = typeof ScreenerInsuranceNetworkStatusOverrideEnum[keyof typeof ScreenerInsuranceNetworkStatusOverrideEnum];

/**
 * @export
 */
export const ScreenerInsuranceCoverageStatusEnum = {
    Active: 'Active',
    Pending: 'Pending',
    NA: 'N/A',
} as const;
export type ScreenerInsuranceCoverageStatusEnum = typeof ScreenerInsuranceCoverageStatusEnum[keyof typeof ScreenerInsuranceCoverageStatusEnum];

/**
 * @export
 */
export const ScreenerInsuranceNetworkStatusEnum = {
    InNetwork: 'in_network',
    OutOfNetwork: 'out_of_network',
} as const;
export type ScreenerInsuranceNetworkStatusEnum = typeof ScreenerInsuranceNetworkStatusEnum[keyof typeof ScreenerInsuranceNetworkStatusEnum];


/**
 * Check if a given object implements the ScreenerInsurance interface.
 */
export function instanceOfScreenerInsurance(value: object): value is ScreenerInsurance {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('payor' in value) || value['payor'] === undefined) return false;
    if (!('coverage_priority' in value) || value['coverage_priority'] === undefined) return false;
    if (!('is_overridden_by_user' in value) || value['is_overridden_by_user'] === undefined) return false;
    return true;
}

export function ScreenerInsuranceFromJSON(json: any): ScreenerInsurance {
    return ScreenerInsuranceFromJSONTyped(json, false);
}

export function ScreenerInsuranceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerInsurance {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'],
        'payor': InsurancePayorFromJSON(json['payor']),
        'type': json['type'] == null ? undefined : json['type'],
        'state': json['state'] == null ? undefined : json['state'],
        'coverage_priority': json['coverage_priority'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'medicare_number': json['medicare_number'] == null ? undefined : json['medicare_number'],
        'medicaid_number': json['medicaid_number'] == null ? undefined : json['medicaid_number'],
        'plan_number': json['plan_number'] == null ? undefined : json['plan_number'],
        'group_number': json['group_number'] == null ? undefined : json['group_number'],
        'is_overridden_by_user': json['is_overridden_by_user'],
        'is_active_payer': json['is_active_payer'] == null ? undefined : json['is_active_payer'],
        'inovalon_payer': json['inovalon_payer'] == null ? undefined : ScreenerInsuranceInovalonPayerFromJSON(json['inovalon_payer']),
        'inovalon_mapping_mismatch': json['inovalon_mapping_mismatch'] == null ? undefined : json['inovalon_mapping_mismatch'],
        'stedi_payer': json['stedi_payer'] == null ? undefined : StediPayerFromJSON(json['stedi_payer']),
        'stedi_mapping_status': json['stedi_mapping_status'] == null ? undefined : json['stedi_mapping_status'],
        'stedi_enrollment_required': json['stedi_enrollment_required'] == null ? undefined : json['stedi_enrollment_required'],
        'stedi_mapping_mismatch': json['stedi_mapping_mismatch'] == null ? undefined : json['stedi_mapping_mismatch'],
        'received_from_cache_key': json['received_from_cache_key'] == null ? undefined : json['received_from_cache_key'],
        'network_status_override': json['network_status_override'] == null ? undefined : json['network_status_override'],
        'coverage_status': json['coverage_status'] == null ? undefined : json['coverage_status'],
        'network_status': json['network_status'] == null ? undefined : json['network_status'],
    };
}

export function ScreenerInsuranceToJSON(json: any): ScreenerInsurance {
    return ScreenerInsuranceToJSONTyped(json, false);
}

export function ScreenerInsuranceToJSONTyped(value?: ScreenerInsurance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'payor': InsurancePayorToJSON(value['payor']),
        'type': value['type'],
        'state': value['state'],
        'coverage_priority': value['coverage_priority'],
        'plan_name': value['plan_name'],
        'medicare_number': value['medicare_number'],
        'medicaid_number': value['medicaid_number'],
        'plan_number': value['plan_number'],
        'group_number': value['group_number'],
        'is_overridden_by_user': value['is_overridden_by_user'],
        'is_active_payer': value['is_active_payer'],
        'inovalon_payer': ScreenerInsuranceInovalonPayerToJSON(value['inovalon_payer']),
        'inovalon_mapping_mismatch': value['inovalon_mapping_mismatch'],
        'stedi_payer': StediPayerToJSON(value['stedi_payer']),
        'stedi_mapping_status': value['stedi_mapping_status'],
        'stedi_enrollment_required': value['stedi_enrollment_required'],
        'stedi_mapping_mismatch': value['stedi_mapping_mismatch'],
        'received_from_cache_key': value['received_from_cache_key'],
        'network_status_override': value['network_status_override'],
        'coverage_status': value['coverage_status'],
        'network_status': value['network_status'],
    };
}

